import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'days'
})
export class DaysPipe implements PipeTransform {

  transform(value: any): string {
    var sec_num = parseInt(value, 10); // don't forget the second param
    var days = Math.floor(sec_num / 3600 / 24);

    return days > 9 ? `${days}` : `0${days}`;
  }

}
